<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="2">
        <span class="font-weight-black">예약자</span>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <span style="cursor: pointer" @click="reservationData[0].customerId ? $router.push(`/customers/${reservationData[0].customerId.id}`) : ''">
          {{getReservationData('customerName')}}
        </span>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <span class="font-weight-black">예약 날짜</span>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <span>{{getReservationData('created')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">연락처</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <span>{{getReservationData('customerNo')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black align-self-center">비상 연락처</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <span>{{getReservationData('familyNo')}} {{getReservationData('familyRelation')}}</span>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-row>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">출발 시간</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationData('startTime')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">서비스 종료 시간</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationData('endTime')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">소요 시간</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationData('driveTime')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">예약 인원</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationData('customerCnt')}}</span>
        <span>명</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">도움서비스 시간</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationData('serviceTime')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">도움서비스 내용</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationData('customerComment')}}</span>
      </v-col>


      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">차량 이용 대수</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{getReservationData('vehicleCnt')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">차종</span>
      </v-col>
      <v-col cols="12" md="4" sm="6">
        <span>{{ getReservationData('vehicleType') }}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">용도</span>
      </v-col>
      <v-col cols="12" md="4" sm="6" >
        <span>{{getReservationData('customerUsage')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">차량 옵션</span>
      </v-col>
      <v-col cols="12" md="4" sm="6" >
        <span>{{getReservationData('vehicleOption')}}</span>
      </v-col>



      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">수하물</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <span>{{getReservationData('luggage')}}</span>
      </v-col>

    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" md="2" sm="6" class="align-self-center">
        <span class="font-weight-black">출발지</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <div>{{getReservationData('departure')}}</div>
          <span>{{getReservationData('departureComment')}}</span>
      </v-col>
      <v-col cols="12" md="2" sm="6" class="align-self-center">
        <span class="font-weight-black">도착지</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <div>{{getReservationData('destination')}}</div>
        <div>
            <span>{{getReservationData('destinationComment')}}</span>
        </div>
      </v-col>
      <template v-if="getReservationData('waypoint1')">
        <v-col cols="12" md="2" sm="6" class="align-self-center">
          <span class="font-weight-black">경유지 1</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <div>{{getReservationData('waypoint1')}}</div>
          <div>
            <span>{{getReservationData('waypoint1Comment')}}</span>
          </div>
        </v-col>
      </template>
      <template v-if="getReservationData('waypoint2')">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">경유지 2</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <div>{{getReservationData('waypoint2')}}</div>
          <div>
            <span>{{getReservationData('waypoint2Comment')}}</span>
          </div>
        </v-col>
      </template>
      <template v-if="getReservationData('waypoint3')">
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">경유지 3</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <div>{{getReservationData('waypoint3')}}</div>
          <div>
            <span>{{getReservationData('waypoint3Comment')}}</span>
          </div>
        </v-col>
      </template>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" md="2" sm="6" class="align-self-center">
        <span class="font-weight-black">예약 진행 상황</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <v-chip v-on="on" :class="resrvColor" dark>{{ getReservationData('resrvState')}}</v-chip>
      </v-col>
      <template v-if="checkReservationState(reservationData) === 'rs_cancel' || checkReservationState(reservationData) === 'rs_user_cancel'" >
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">취소 시각</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ getReservationData('created')}}</span>
        </v-col>
        <v-col cols="12" md="2" sm="6">
          <span class="font-weight-black">취소 사유</span>
        </v-col>
        <v-col cols="12" md="10" sm="6">
          <span>{{ getReservationData('cancelComment') ? '일정 변경 및 취소' : '-' }}</span>
        </v-col>
      </template>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">배정 기사</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <div v-for="item in getReservationData('driverId')">
          <span style="cursor: pointer" @click="item ? $route.path !== `/drivers/${item.id}` ? $router.push(`/drivers/${item.id}`) : '' : ''">
            {{ item ? item.name : '-' }}
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="2" sm="6">
        <span class="font-weight-black">배정 차량</span>
      </v-col>
      <v-col cols="12" md="10" sm="6">
        <div v-for="item in getReservationData('vehicleId')">{{ item ? ( (item.plateNo||'') + ' | ' +
          (item.modelName||'')) : '-' }}
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
  import {mask} from 'vue-the-mask';

  export default {

    directives: {mask},
    data: () => ({
      maskMobileNo: '010-####-####',

      resrvColor: '',
      vehicleModel: '',
      vehicleTypeList: [],
      driverList: [],

      manualDialogOpen: false,
      autoDialogOpen: false,
      reservationId: null,

    }),
    props: {
      reservationEditableFlag: {
        type: Boolean,
      },
      reservationStateEventFlag: {
        type: Boolean,
      },
      reservationData: {
        type: Array,
        default: []
      },
      customerData: {
        type: Object,
      },
    },
    methods: {
      getReservationData(key) {
        if (this.reservationData && this.reservationData.length > 0) {
          let data = this.reservationData[0][key];
          if (key === 'created') {
            data = this.$func.dateTimeToString(data);
          } else if (key === 'driveTime') {
            data= this.$func.msToTimeFormat(data);
          } else if (key === 'resrvState') {
            let value = data.configValue;
            if (value === 'rs_complete') {
              this.resrvColor = 'light1Green';
            } else if (value === "rs_driving") {
              this.resrvColor = 'blue';
            } else if (value === 'rs_done') {
              this.resrvColor = 'light2Blue';
            } else if (value === 'rs_cancel') {
              this.resrvColor = 'light2Grey';
            } else if (value === 'rs_receipt') {
              this.resrvColor = 'light1Red';
            } else if (value === 'rs_user_cancel') {
              this.resrvColor = 'red'
            }
            data = data.configName;
          } else if (key === 'driverId') {
            return this.reservationData.map((item) => item.driverId);
          } else if (key === 'vehicleId') {
            return this.reservationData.map((item) => item.vehicleId);
            // data = data ? data.plateNo + ' | ' + data.modelName : '-';
          } else if (key === 'vehicleType') {
            let vehicleType = [];
            let types = data.split(',');

            for (const i in types) {
              let vehicle = types[i];
              if (vehicle === 'c_11seat') {
                vehicleType.push('11인승');
              }
              if (vehicle === 'c_15seat') {
                vehicleType.push('15인승');
              }
              if (vehicle === 'c_5seat') {
                vehicleType.push('승용차');
              }
              if (vehicle === 'c_9seat') {
                vehicleType.push('9인승');
              }
            }
            data = vehicleType.toString();
          } else if (key === 'vehicleOption') {
            if(!data) return '-';
            let vehicleOption = [];
            if(!data) {
              return '-';
            }
            let options = data.split(',');

            options.forEach((option) => {
              if (option === 'c_wcl'){
                vehicleOption.push("휠체어 리프트");
              }else {
                vehicleOption.push("없음");
              }
            });
            data = vehicleOption.toString();
          }
          return data;

        } else {
          return '';
        }
      },
      async reqReservation() {
        try {
          const res = await this.$api.getReservation(this.reservationId);
          this.reservationData = res.data;
          await this.reqGetCustomerOfReservation();
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqReservation'});
        }
      },
      async reqGetCustomerOfReservation() {
        try {
          if (!this.reservationData || !this.reservationData[0] || !this.reservationData[0].customerId) return;
          const res = await this.$api.getCustomer(this.reservationData[0].customerId.id);
          this.customerData = res.data;
        } catch (err) {
          this.$store.commit('snackbar', {err, where: 'reqGetCustomerOfReservation'});
        }
      },
      checkReservationState(reservationData) {
        if (!reservationData || !reservationData[0] || !reservationData[0].resrvState) return;
        return reservationData[0].resrvState.configValue;
      },
    },
    mounted() {
      const {reservationId} = this.$route.params;
      this.reservationId = reservationId;
      /* this.reqReservation(); */
    },
  }
</script>
<style scoped>
  .waypoint {
    margin-top: 3px;
  }

  .infoEditTextField {
    font-size: 15px;
    font-weight: bold;
  }
</style>
